import { Card } from "@omni/ui/components/Card/card";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Title = ({ className, children }: Props) => {
    return (
        <Card.Title
            tag="div"
            className={cn("tw:font-bold", className)}
        >
            {children}
        </Card.Title>
    );
};
